export default "__VITE_ASSET__B$57iKo1__"